<template>
  <img 
    :src="currentSrc" 
    :alt="alt" 
    :class="imgClass"
    :loading="loading"
    @error="handleError"
  />
</template>

<script>
export default {
  name: 'ImageWithFallback',
  props: {
    src: {
      type: String,
      required: true
    },
    fallbackSrc: {
      type: String,
      default: null
    },
    alt: {
      type: String,
      default: ''
    },
    imgClass: {
      type: String,
      default: 'img-fluid'
    },
    loading: {
      type: String,
      default: 'eager'
    }
  },
  data() {
    return {
      currentSrc: this.src,
      errorCount: 0
    };
  },
  watch: {
    src(newSrc) {
      this.currentSrc = newSrc;
      this.errorCount = 0;
    }
  },
  methods: {
    handleError() {
      this.errorCount++;
      
      // Try fallback strategies
      if (this.errorCount === 1 && this.fallbackSrc) {
        // First try: use provided fallback
        this.currentSrc = this.fallbackSrc;
      } else if (this.errorCount === 2) {
        // Second try: try public path
        const filename = this.src.split('/').pop();
        this.currentSrc = `/dev/images/logos/${filename}`;
      } else if (this.errorCount === 3) {
        // Third try: placeholder
        this.currentSrc = 'data:image/svg+xml,%3Csvg xmlns="http://www.w3.org/2000/svg" width="200" height="100"%3E%3Crect width="200" height="100" fill="%2387b140" opacity="0.1"/%3E%3Ctext x="50%25" y="50%25" text-anchor="middle" dy=".3em" fill="%2387b140" font-family="sans-serif" font-size="14"%3EImage%3C/text%3E%3C/svg%3E';
      }
    }
  }
};
</script>